// extracted by mini-css-extract-plugin
export default {"input":"Vba-z","button":"Wba-z","selected":"Xba-z","unavailable":"Yba-z","oos":"Zba-z","paperCutDisabledOverlay":"_ba-z","image":"aca-z"};